require('./brokerPensionPlanInfo.scss');

// @ vendors
const React = require('react');
//const PropTypes = require('prop-types');
//const classNames = require('classnames');
// @ helpers
const { FormattedText } = require('core/i18n').i18n;
// @ components
// @ constants
const { Accordion } = require('commonsComponents/accordion');
const { AccordionHeader } = require('commonsComponents/accordionHeader');
const { AccordionBody } = require('commonsComponents/accordionBody');
//@utilities
const { scrollToTop } = require('commonsUtilities/scrollUtils');

class brokerPensionPlanInfo extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        scrollToTop();
    }

    createFifthAccordion() {
        return (
            <Accordion onClick={this.handleOnClick} isExpanded={false} customClassName="broker-pension-plan-info__accordion">
                <AccordionHeader name="AccordionHeader" canBeExpanded={true} isRightArrowPosition={true} iconStyle="secondary">
                    <FormattedText value="pensionPlanInfo-accordionHeader5" className="broker-pension-plan-info__accordion-header"/>
                </AccordionHeader>
                <AccordionBody name="AccordionBody">
                    <div className="broker-pension-plan-info__accordionbody">
                        <p>
                            <FormattedText value="pensionPlanInfo-accordion5Paragraph1" />
                        </p>
                        <ul className="broker-pension-plan-info__list--first">
                            <li>
                                <FormattedText value="pensionPlanInfo-accordion5Paragraph2" />
                            </li>
                            <li>
                                <FormattedText value="pensionPlanInfo-accordion5Paragraph3" />
                            </li>
                            <li>
                                <FormattedText value="pensionPlanInfo-accordion5Paragraph4" />
                            </li>
                            <li>
                                <FormattedText value="pensionPlanInfo-accordion5Paragraph5" />
                            </li>
                        </ul>
                    </div>
                </AccordionBody>
            </Accordion>
        );
    }

    createFirstAccordion() {
        return (
            <Accordion onClick={this.handleOnClick} isExpanded={true} customClassName="broker-pension-plan-info__accordion">
                <AccordionHeader name="AccordionHeader" canBeExpanded={true} isRightArrowPosition={true} iconStyle="secondary">
                    <FormattedText value="pensionPlanInfo-accordionHeader1" className="broker-pension-plan-info__accordion-header"/>
                </AccordionHeader>
                <AccordionBody name="AccordionBody">
                    <div className="broker-pension-plan-info__accordionbody">
                        <p><FormattedText value="pensionPlanInfo-accordion1Paragraph1" /></p>
                        <p><FormattedText value="pensionPlanInfo-accordion1Paragraph2" /></p>
                        <p><FormattedText value="pensionPlanInfo-accordion1Paragraph3" /></p>
                        <p><FormattedText value="pensionPlanInfo-accordion1Paragraph4" /></p>
                        <p>a) <FormattedText value="pensionPlanInfo-accordion1Paragraph5" /></p>
                        <ul className="broker-pension-plan-info__list--first">
                            <li>
                                <FormattedText value="pensionPlanInfo-accordion1Paragraph6" />
                            </li>
                            <li>
                                <FormattedText value="pensionPlanInfo-accordion1Paragraph7" />
                            </li>
                            <li>
                                <FormattedText value="pensionPlanInfo-accordion1Paragraph8" />
                            </li>
                            <li>
                                <FormattedText value="pensionPlanInfo-accordion1Paragraph9" />
                            </li>
                        </ul>
                        <p>b) <FormattedText value="pensionPlanInfo-accordion1Paragraph10" /></p>
                        <ul className="broker-pension-plan-info__list--first">
                            <li>
                                <FormattedText value="pensionPlanInfo-accordion1Paragraph11" />
                            </li>
                            <li>
                                <FormattedText value="pensionPlanInfo-accordion1Paragraph12" />
                            </li>
                        </ul>
                        <p>
                            <FormattedText value="pensionPlanInfo-accordion1Paragraph13" />
                        </p>
                        <p>
                            <FormattedText value="pensionPlanInfo-accordion1Paragraph14" />
                        </p>
                        <ul className="broker-pension-plan-info__list--first">
                            <li>
                                <FormattedText value="pensionPlanInfo-accordion1Paragraph15" />
                            </li>
                            <li>
                                <FormattedText value="pensionPlanInfo-accordion1Paragraph16" />
                            </li>
                            <li>
                                <FormattedText value="pensionPlanInfo-accordion1Paragraph17" />
                            </li>
                            <li>
                                <FormattedText value="pensionPlanInfo-accordion1Paragraph18" />
                            </li>
                            <li>
                                <FormattedText value="pensionPlanInfo-accordion1Paragraph19" />
                            </li>
                            <li>
                                <FormattedText value="pensionPlanInfo-accordion1Paragraph20" />
                            </li>
                        </ul>
                    </div>
                </AccordionBody>
            </Accordion>
        );
    }

    createFourthAccordion() {
        return (
            <Accordion onClick={this.handleOnClick} isExpanded={false} customClassName="broker-pension-plan-info__accordion">
                <AccordionHeader name="AccordionHeader" canBeExpanded={true} isRightArrowPosition={true} iconStyle="secondary">
                    <FormattedText value="pensionPlanInfo-accordionHeader4" className="broker-pension-plan-info__accordion-header"/>
                </AccordionHeader>
                <AccordionBody name="AccordionBody">
                    <div className="broker-pension-plan-info__accordionbody">
                        <p>
                            <FormattedText value="pensionPlanInfo-accordion4Paragraph1" />
                        </p>
                        <p>
                            <FormattedText value="pensionPlanInfo-accordion4Paragraph2" />
                        </p>
                        <ul className="broker-pension-plan-info__list--first">
                            <li>
                                <FormattedText value="pensionPlanInfo-accordion4Paragraph3" />
                            </li>
                            <li>
                                <FormattedText value="pensionPlanInfo-accordion4Paragraph4" />
                            </li>
                            <li>
                                <FormattedText value="pensionPlanInfo-accordion4Paragraph5" />
                            </li>
                            <li>
                                <FormattedText value="pensionPlanInfo-accordion4Paragraph6" />
                            </li>
                        </ul>
                    </div>
                </AccordionBody>
            </Accordion>
        );
    }

    createSecondAccordion() {
        return (
            <Accordion onClick={this.handleOnClick} isExpanded={false} customClassName="broker-pension-plan-info__accordion">
                <AccordionHeader name="AccordionHeader" canBeExpanded={true} isRightArrowPosition={true} iconStyle="secondary">
                    <FormattedText value="pensionPlanInfo-accordionHeader2" className="broker-pension-plan-info__accordion-header"/>
                </AccordionHeader>
                <AccordionBody name="AccordionBody">
                    <div className="broker-pension-plan-info__accordionbody">
                        <p>
                            <FormattedText value="pensionPlanInfo-accordion2Paragraph1" />
                        </p>
                        <p>
                            <FormattedText value="pensionPlanInfo-accordion2Paragraph2" />
                        </p>
                        <ul className="broker-pension-plan-info__list--first">
                            <li>
                                <FormattedText value="pensionPlanInfo-accordion2Paragraph3" />
                            </li>
                            <li>
                                <FormattedText value="pensionPlanInfo-accordion2Paragraph4" />
                            </li>
                            <li>
                                <FormattedText value="pensionPlanInfo-accordion2Paragraph5" />
                            </li>
                            <li>
                                <FormattedText value="pensionPlanInfo-accordion2Paragraph6" />
                            </li>
                        </ul>
                    </div>
                </AccordionBody>
            </Accordion>
        );
    }

    createSeventhAccordion() {
        return (
            <Accordion onClick={this.handleOnClick} isExpanded={false} customClassName="broker-pension-plan-info__accordion">
                <AccordionHeader name="AccordionHeader" canBeExpanded={true} isRightArrowPosition={true} iconStyle="secondary">
                    <FormattedText value="pensionPlanInfo-accordionHeader7" className="broker-pension-plan-info__accordion-header"/>
                </AccordionHeader>
                <AccordionBody name="AccordionBody">
                    <div className="broker-pension-plan-info__accordionbody">
                        <p>
                            <FormattedText value="pensionPlanInfo-accordionHeader7Paragraph1" />
                        </p>
                        <ul className="broker-pension-plan-info__list--third">
                            <li>
                                <FormattedText value="pensionPlanInfo-accordionHeader7Paragraph2" />
                            </li>
                            <li>
                                <FormattedText value="pensionPlanInfo-accordionHeader7Paragraph3" />
                            </li>
                            <li>
                                <FormattedText value="pensionPlanInfo-accordionHeader7Paragraph4" />
                            </li>
                            <li>
                                <FormattedText value="pensionPlanInfo-accordionHeader7Paragraph5" />
                            </li>
                            <li>
                                <FormattedText value="pensionPlanInfo-accordionHeader7Paragraph6" />
                            </li>
                            <li>
                                <FormattedText value="pensionPlanInfo-aaccordionHeader7Paragraph7" />
                            </li>
                        </ul>
                    </div>
                </AccordionBody>
            </Accordion>
        );
    }

    createSixthAccordion() {
        return (
            <Accordion onClick={this.handleOnClick} isExpanded={false} customClassName="broker-pension-plan-info__accordion">
                <AccordionHeader name="AccordionHeader" canBeExpanded={true} isRightArrowPosition={true} iconStyle="secondary">
                    <FormattedText value="pensionPlanInfo-accordionHeader6" className="broker-pension-plan-info__accordion-header"/>
                </AccordionHeader>
                <AccordionBody name="AccordionBody">
                    <div className="broker-pension-plan-info__accordionbody">
                        <p><FormattedText value="pensionPlanInfo-accordion6Paragraph1" /></p>
                        <ul className="broker-pension-plan-info__accordion-subtitle">
                            <li><FormattedText value="pensionPlanInfo-accordion6Subtitle1" /></li>
                        </ul>
                        <p><FormattedText value="pensionPlanInfo-accordion6Paragraph2" /></p>
                        <p><FormattedText value="pensionPlanInfo-accordion6Paragraph3" /></p>
                        <p><FormattedText value="pensionPlanInfo-accordion6Paragraph4" /></p>
                        <p><FormattedText value="pensionPlanInfo-accordion6Paragraph5" /></p>
                        <p><FormattedText value="pensionPlanInfo-accordion6Paragraph6" /></p>
                        <ul className="broker-pension-plan-info__list--first">
                            <li><FormattedText value="pensionPlanInfo-accordion6Paragraph7" /></li>
                            <li><FormattedText value="pensionPlanInfo-accordion6Paragraph8" /></li>
                            <li><FormattedText value="pensionPlanInfo-accordion6Paragraph9" /></li>
                            <li><FormattedText value="pensionPlanInfo-accordion6Paragraph10" /></li>
                        </ul>
                        <ul className="broker-pension-plan-info__accordion-subtitle">
                            <li><FormattedText value="pensionPlanInfo-accordion6Subtitle2" /></li>
                        </ul>
                        <p><FormattedText value="pensionPlanInfo-accordion6Paragraph11" /></p>
                        <ol className="broker-pension-plan-info__list--second">
                            <li><FormattedText value="pensionPlanInfo-accordion6Paragraph12" /></li>
                            <li><FormattedText value="pensionPlanInfo-accordion6Paragraph13" /></li>
                        </ol>
                        <p><FormattedText value="pensionPlanInfo-accordion6Paragraph14" /></p>
                        <p><FormattedText value="pensionPlanInfo-accordion6Paragraph15" /></p>
                        <p><FormattedText value="pensionPlanInfo-accordion6Paragraph16" /></p>
                        <ul className="broker-pension-plan-info__list--first">
                            <li><FormattedText value="pensionPlanInfo-accordion6Paragraph17" /></li>
                            <li><FormattedText value="pensionPlanInfo-accordion6Paragraph18" /></li>
                            <li><FormattedText value="pensionPlanInfo-accordion6Paragraph19" /></li>
                            <li><FormattedText value="pensionPlanInfo-accordion6Paragraph20" /></li>
                        </ul>
                    </div>
                </AccordionBody>
            </Accordion>
        );
    }

    createThirdAccordion() {
        return (
            <Accordion onClick={this.handleOnClick} isExpanded={false} customClassName="broker-pension-plan-info__accordion">
                <AccordionHeader name="AccordionHeader" canBeExpanded={true} isRightArrowPosition={true} iconStyle="secondary">
                    <FormattedText value="pensionPlanInfo-accordionHeader3" className="broker-pension-plan-info__accordion-header"/>
                </AccordionHeader>
                <AccordionBody name="AccordionBody">
                    <div className="broker-pension-plan-info__accordionbody">
                        <p>
                            <FormattedText value="pensionPlanInfo-accordion3Paragraph1" />
                        </p>
                        <p>
                            <FormattedText value="pensionPlanInfo-accordion3Paragraph2" />
                        </p>
                        <ul className="broker-pension-plan-info__list--first">
                            <li>
                                <FormattedText value="pensionPlanInfo-accordion3Paragraph3" />
                            </li>
                            <li>
                                <FormattedText value="pensionPlanInfo-accordion3Paragraph4" />
                            </li>
                            <li>
                                <FormattedText value="pensionPlanInfo-accordion3Paragraph5" />
                            </li>
                            <li>
                                <FormattedText value="pensionPlanInfo-accordion3Paragraph6" />
                            </li>
                        </ul>
                    </div>
                </AccordionBody>
            </Accordion>
        );
    }

    render() {
        return (
            <article className="broker-pension-plan-info">
                <header className="broker-pension-plan-info__header">
                    <FormattedText
                        value="pensionPlanInfo-infoTitle"
                        className="broker-pension-plan-info__title"
                    />
                </header>
                <span className="broker-pension-plan-info__separator" />
                <p>
                    <FormattedText value="pensionPlanInfo-subtitle" />
                </p>
                <div className="broker-pension-plan-info__accordion-wrapper">
                    {this.createFirstAccordion()}
                    {this.createSecondAccordion()}
                    {this.createThirdAccordion()}
                    {this.createFourthAccordion()}
                    {this.createFifthAccordion()}
                    {this.createSixthAccordion()}
                    {this.createSeventhAccordion()}
                </div>
            </article>
        );
    }
}

brokerPensionPlanInfo.propTypes = {};

module.exports = brokerPensionPlanInfo;
